import UrlParse from 'url-parse';
import UrlJoin from 'urljoin';


export const parse = (url) => {
    return new UrlParse(url);
};

/**
 * @returns {String}
 * @param urls {string[]}
 */
export const join = (urls) => {
    return UrlJoin(...urls);
};


// WEBPACK FOOTER //
// ./utilities/url.js